<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-09 13:25:18
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-27 19:08:54
 * @Description: 开票明细
-->
<template>
  <div>
    <el-form class="invoicing-details" :inline="true" :model="dataForm">
      <el-form-item label="">
        <el-input
          clearable
          v-model="dataForm.goodsCode"
          @clear="doSearch"
          placeholder="商品编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input
          clearable
          @clear="doSearch"
          v-model="dataForm.goodsName"
          placeholder="商品名称模糊"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="doSearch">查询</el-button>
        <!-- <el-button type="primary" size="small" @click="handlerExport">导出明细</el-button> -->
      </el-form-item>
    </el-form>
    <el-table
      :summary-method="getSummaries"
      show-summary
      :data="pageList"
      border
      style="width: 100%"
    >
      <el-table-column
        type="index"
        width="50"
        align="center"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="orderCode"
        header-align="center"
        align="center"
        label="订单编号"
      >
      </el-table-column>
      <el-table-column
        prop="goodsCode"
        header-align="center"
        align="center"
        label="商品编码"
      >
      </el-table-column>
      <el-table-column
        prop="goodsName"
        header-align="center"
        align="center"
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        prop="goodsModel"
        header-align="center"
        align="center"
        label="型号"
      >
      </el-table-column>
      <el-table-column
        prop="goodsUnit"
        header-align="center"
        align="center"
        label="单位"
      >
      </el-table-column>
      <el-table-column
        prop="goodsNum"
        header-align="center"
        align="center"
        label="已开/全部数量"
      >
        <template slot-scope="scope">
          {{ scope.row.hasInvoiceNum }} /
          {{ scope.row.goodsNum }}
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="已开/全部金额"
      >
        <template slot-scope="scope">
          {{ scope.row.hasInvoiceAmount }} / {{ scope.row.goodsMoney }}
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceNum"
        header-align="center"
        align="center"
        label="本次开票数量"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        prop="transactionPrice"
        align="right"
        label="含税单价"
      >
        <template slot-scope="scope">
          {{ scope.row.transactionPrice | formatePriceNormal }}
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        prop="invoiceAmount"
        align="right"
        label="本次开票金额"
      >
        <template slot-scope="scope">
          {{ scope.row.invoiceAmount | formatePriceNormal }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.page"
      :page-sizes="pageSizes"
      :page-size="page.limit"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="showList.length"
    >
    </el-pagination>
  </div>
</template>

<script>
import { formatePrice } from '@/utils/formatePrice'
import tableTotal from '@/utils/tableTotal'
import { tableToExcel } from '@/utils/tableToExcel'

export default {
  filters: {
    formatePrice (val) {
      if (val) {
        return formatePrice(val.toFixed(2))
      }
      return '0.00'
    },
    formatePriceNormal (val) {
      if (val) {
        return formatePrice(val)
      }
      return '0.00'
    }
  },
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      checkAfterSalesVisible: false,
      afterSalesData: [],
      afterSalesSuccessFc: undefined,
      page: {
        page: 1, // 第几页
        limit: 20 // 一页多少条
      },
      pageSizes: [10, 20, 50, 100, 200],
      showList: [], // 要显示的数据
      pageList: [], // 分页数据
      tableTotal: {
        含税总价: '',
        本次开票金额: '',
        本次开票数量: ''
      },
      dataForm: {
        goodsCode: '',
        goodsName: ''
      }
    }
  },

  methods: {
    // 展示售后信息
    onCheckAfterSales (fc = () => {}) {
      const obj = {
        orderParams: this.showList.map(
          ({ orderCode, goodsCode, invoiceNum, invoiceApplyId }) => {
            return {
              orderCode,
              goodsCode,
              invoiceNum,
              invoiceApplyId
            }
          }
        )
      }
      this.$http
        .post('/help/oms/invoiceApply/getCheckInvoiceApply', obj)
        .then(({ data: { data } }) => {
          this.afterSalesData = data || {}
          this.afterSalesSuccessFc = () => {
            this.checkAfterSalesVisible = false
            fc()
          }
          this.checkAfterSalesVisible = true
        })
    },
    setPageList () {
      const start = (this.page.page - 1) * this.page.limit
      const end = this.page.page * this.page.limit
      console.log(this.showList, start, end)
      this.pageList = this.showList.slice(start, end)
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.page.page = val
      // 刷新列表数据
      this.setPageList()
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.page.page = 1
      this.page.limit = val
      // 刷新列表数据
      this.setPageList()
      scrollTo(0, 500)
    },
    // 隐藏开票完的
    setShowList () {
      this.showList = this.filter(this.dataForm, [...this.list])
      // 刷新列表数据
      this.setPageList()
    },
    // 前端查询
    doSearch () {
      this.page.page = 1
      this.setShowList()
    },
    // 过滤数据
    filter (condition, data) {
      return data.filter(item => {
        return Object.keys(condition).every(key => {
          return String(item[key])
            .toLowerCase()
            .includes(
              String(condition[key])
                .trim()
                .toLowerCase()
            )
        })
      })
    },
    handlerExport () {
      if (this.list.length === 0) {
        this.$message.warning('没有要导出的内容')
        return
      }
      const data = this.list.map(i => {
        return {
          ...i,
          goodsNumTotal: `${i.hasInvoiceNum}/${i.goodsNum}&nbsp;`,
          amountTotal: `${i.hasInvoiceAmount}/${i.goodsMoney}&nbsp;`,
          taxRateStr: `${i.taxRate * 100}%`,
          taxCode: i.taxCode ? `${i.taxCode}&nbsp;` : ''
        }
      })

      const titles = {
        orderCode: '所属订单号',
        goodsCode: '商品编码',
        goodsName: '商品名称',
        goodsModel: '型号',
        goodsUnit: '单位',
        goodsNumTotal: '已开/全部数量',
        amountTotal: '已开/全部金额',
        transactionPrice: '含税单价',
        goodsMoney: '含税总价',
        taxRateStr: '税率',
        invoiceNum: '本次开票数量',
        invoiceAmount: '本次开票金额',
        taxCode: '税收编码',
        taxName: '税收名称'
      }
      tableToExcel({ data, titles, fileName: '开票明细导出.xls' })
    },
    // 表格底部合计
    getSummaries (param) {
      return tableTotal(param, this.tableTotal)
    }
  },
  watch: {
    list () {
      this.doSearch()
    }
  }
}
</script>

<style lang="scss" scoped></style>
